import script from "./Page.vue?vue&type=script&setup=true&lang=js"
export * from "./Page.vue?vue&type=script&setup=true&lang=js"

import "./Page.vue?vue&type=style&index=0&id=1f838914&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f838914"]])

export default __exports__